import { render, staticRenderFns } from "./EmployeeSalaryTransaction.vue?vue&type=template&id=840531c8&"
import script from "./EmployeeSalaryTransaction.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaryTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports